import { render, staticRenderFns } from "./organizationDetails.vue?vue&type=template&id=aecfe0f0&scoped=true&"
import script from "./organizationDetails.vue?vue&type=script&lang=js&"
export * from "./organizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./organizationDetails.vue?vue&type=style&index=0&id=aecfe0f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecfe0f0",
  null
  
)

export default component.exports